import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import HeaderFixed from "../component/header/HeaderFixed";
import Footer from "../component/footer/Footer";
import TabsLogin from "./tab/TabsLogin";

const AnyReactComponent = ({ text }) => <div>{text}</div>;

class RefundPolicy extends Component{
    static defaultProps = {
        center: {
            lat: 59.95,
            lng: 30.33
        },
        zoom: 11
    };

    render(){
        return(
            <React.Fragment>
                <PageHelmet pageTitle='Contact' />

                <HeaderFixed />

                 {/* Start Breadcrump Area */}
                 <div className="rn-page-title-area bg_image" style={{backgroundImage: 'url(/assets/images/bg/login-banner.png)', paddingBottom: 152, paddingTop: 96}}>
                    <div style={{transform: 'scale(0.8)'}} className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">Refund Policy</h2>
                                    {/* <p>Contrary to popular belief, Lorem Ipsum is not simply random text. </p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}


                {/* Start Contact Top Area  */}
                <div className="rn-contact-top-area ptb--80 bg_color--5" 
                     style={{
                                backgroundImage: 'url(/assets/images/bg/login-background.jpeg)', 
                                paddingBottom: 152, 
                                paddingTop: 120, 
                                backgroundRepeat: 'no-repeat', 
                                backgroundSize: 'cover', 
                                backgroundPosition: 'center center'
                            }} >
                    <div className="container" style={{transform: 'scale(1)'}}>
                       
                        <div className="row">
                            
                                <div className="row row--35" style={{alignItems: 'center'}}>
                                    <div className="col-sm-12">
                                      <div className="card" style={{padding: 40}}>
                                        <h1 className="text-center">Refund Policy</h1><br/>
            
                                        <h3 className="text-secondary">Interpretation and Definitions</h3>
                                        <hr/>
                                        <h5>Interpretation</h5>
                                        <p>The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</p>
                                        <h5>Definitions</h5>
                                        <p>For the purposes of this Return and Refund Policy:</p>
                                        <ul className="text-left" style={{listStyleType: 'disc', marginLeft: '50px'}}>
                                            <li><p>Company (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to ANTT Robotics Ltd. , Level-04, Software Technology Park, 49, Janata Tower Karwan Bazar, Dhaka- 1215, Bangladesh.</p></li>
                                            <li><p>Goods refer to the items offered for sale on the Service.</p></li>
                                            <li><p>Orders mean a request by You to purchase Goods from Us</p></li>
                                            <li><p>Service refers to the Website.</p></li>
                                            <li><p>Website refers to ANTT Robotics Ltd. , accessible from https://www.anttrobotics.com</p></li>
                                            <li><p>You means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</p></li>
                                        </ul>

                                        <h3 className="text-secondary">Your Order Cancellation Right</h3><hr/>
                                        <p>You are entitled to cancel Your Order within 14 days without giving any reason for doing so.</p>
                                        <p>The deadline for cancelling an Order is 14 days from the date on which You received the Goods or on which a third party you have appointed, who is not the carrier, takes possession of the product delivered.</p>
                                        <p>In order to exercise Your right of cancellation, You must inform Us of your decision by means of a clear statement. You can inform us of your decision by:</p>
                                        <ul style={{listStyleType: 'disc', marginLeft: '20px'}}><li><p>By email: anttrobotics@gmail.com</p></li></ul>
                                        <p>We will reimburse You no later than 14 days from the day on which We receive the returned Goods. We will use the same means of payment as You used for the Order, and You will not incur any fees for such reimbursement.</p>
                                        
                                        <h3 className="text-secondary">Conditions for Returns</h3><hr/>
                                        <p>In order for the Goods to be eligible for a return, please make sure that:</p>
                                        <ul style={{listStyleType: 'disc', marginLeft: '20px'}}>
                                            <li><p>The Goods were purchased in the last 14 days</p></li>
                                            <li><p>The Goods are in the original packaging</p></li>
                                        </ul>
                                        <p>The following Goods cannot be returned:</p>
                                        <ul style={{listStyleType: 'disc', marginLeft: '20px'}}>
                                            <li><p>The supply of Goods made to Your specifications or clearly personalized.</p></li>
                                            <li><p>The supply of Goods which according to their nature are not suitable to be returned, deteriorate rapidly or where the date of expiry is over.</p></li>
                                            <li><p>The supply of Goods which are not suitable for return due to health protection or hygiene reasons and were unsealed after delivery.</p></li>
                                            <li><p>The supply of Goods which are, after delivery, according to their nature, inseparably mixed with other items.</p></li>
                                        </ul>
                                        <p>We reserve the right to refuse returns of any merchandise that does not meet the above return conditions in our sole discretion.</p>
                                        <p>Only regular priced Goods may be refunded. Unfortunately, Goods on sale cannot be refunded. This exclusion may not apply to You if it is not permitted by applicable law.</p>
                                        
                                        <h3 className="text-secondary">Returning Goods</h3><hr/>
                                        <p>You are responsible for the cost and risk of returning the Goods to Us. You should send the Goods at the following address: <br/>ANTT Robotics LTd, Level-04, Software Technology Park, 49, Janata Tower, Karwan Bazar, Dhaka- 1215, Bangladesh</p>
                                        <p>We cannot be held responsible for Goods damaged or lost in return shipment. Therefore, We recommend an insured and trackable mail service. We are unable to issue a refund without actual receipt of the Goods or proof of received return delivery.</p>
                                    
                                        <h3 className="text-secondary">Gifts</h3><hr/>
                                        <p>If the Goods were marked as a gift when purchased and then shipped directly to you, You'll receive a gift credit for the value of your return. Once the returned product is received, a gift certificate will be mailed to You.</p>
                                        <p>If the Goods weren't marked as a gift when purchased, or the gift giver had the Order shipped to themselves to give it to You later, We will send the refund to the gift giver.</p>

                                        <h5>Contact Us</h5>
                                        <p>If you have any questions about our Returns and Refunds Policy, please contact us:</p>
                                        <ul style={{listStyleType: 'disc', marginLeft: '20px'}}><li><p>By email: anttrobotics@gmail.com</p></li></ul>
                                      </div>
                                    </div>
                                </div>
                            
                        </div>
                    </div>
                </div>
                {/* End Contact Top Area  */}

                {/* Start Contact Page Area  */}
                <div className="rn-contact-page ptb--60 bg_color--1">
                    <div className="contact-form--1">
                        
                    </div>
                </div>
                {/* End Contact Page Area  */}

                {/* Start Contact Map  */}
                {/* <div className="rn-contact-map-area position-relative">
                    <div style={{ height: '520px', width: '100%' }}>
                        <GoogleMapReact
                        defaultCenter={this.props.center}
                        defaultZoom={this.props.zoom}
                        >
                        <AnyReactComponent
                            lat={23.7800221}
                            lng={90.4244863}
                            text="ANTT Robotics R&D office"
                        />
                        </GoogleMapReact>
                    </div>
                </div> */}
                {/* End Contact Map  */}
                

                {/* Start Brand Area */}
                {/* <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <BrandTwo />
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* End Brand Area */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer topMargin={-170} />
                
            </React.Fragment>
        )
    }
}
export default RefundPolicy